export const ECHEQS_MASS_MANAGEMENT_LIST_PATH = "/v2/echeqs/mass-management";
export const ECHEQS_MASS_MANAGEMENT_NEW_PATH = "/v2/echeqs/mass-management/new";
export const ECHEQS_MASS_MANAGEMENT_CONFIRM_PATH = "/v2/echeqs/mass-management/confirm";
export const ECHEQS_MASS_MANAGEMENT_TICKET_PATH = "/v2/echeqs/mass-management/ticket";

export const BATCH_STATUS = {
    PROCESSING: "PROCESSING",
    FINISHED_SUCCESS: "FINISHED_SUCCESS",
    FINISHED_ERROR: "FINISHED_ERROR",
    FAILED: "FAILED",
};

export const resolveManagementActionI18nKey = (action) => (action ? `echeq.massive.manage.action.${action}` : null);
